fx.ns("desktop.book.edition", class ThemeAlbum extends fx.Component{
    
	constructor()
	{
		super();
		this.destroyOnSwitch = true;

        if (fx.get("mode") == "created-ia")
			this.effect = "vslidein";
		else
		{
			this.showEffect = "hslideout";
			this.hideEffect = "hslidein";
		}
	}

	get themeTag()
	{
		if (this.data.choosedThemeTag)
			return this.data.choosedThemeTag;
		else
		 	return this.data.creator.selectedThemetag
	}

	create()
	{
        let box = new fx.components.Box();

		this.title = new fx.components.Text({text :fx.text("Choisissez le thème de votre album"), className : "title center"});
		box.addChild(this.title, {width:"100%", height : 40, top : 40, left : "center"});

		this.containerCategories = new fx.components.HBox("themes center"); 
		this.containerCategories.visibleAtStart = false;
		this.containerCategories.effect = "fade";
	
		box.addChild(this.containerCategories, {width:"100%", height : "fill", top : 100, left : "center"});
		
		this.addChild(box, { width : "100%", height : "100%", top : 0, left : 0});

		this.backContainer = new fx.components.Box();
		this.backButton = new fx.components.IconButton( {icon: fx.get("assets").arrowBack} );
		let backtext = new fx.components.Text({text : fx.text(fx.get("mode") ==  "creating" ? "Retour" : "Type d'album"), className : "button-label link right-label"});
		this.backContainer.addChild(this.backButton, {width:40, height:40, left : 0, top : 0})
		this.backContainer.addChild(backtext, {width: 150, height : 20, top : 10, left : 40})
		this.addChild( this.backContainer, {top : 15, left : 15, width:150, height:40});

		if (fx.get("mode") == "created-ia")
		{
			this.exitContainer = new fx.components.Box("back-container");
            this.exitButton = new fx.components.IconButton( {icon: fx.assets.ExitIcon} );
            let text = new fx.components.Text({text : fx.text("Fermer"), className : "button-label link"});
            this.exitContainer.addChild(text, {width: 100, height : 20, top : 10, left : 0})
            this.exitContainer.addChild(this.exitButton, {width:40, height:40, left : 110, top : 0})
            this.addChild( this.exitContainer, {top : 15, right : 15, width:150, height:40});
		}
		
		if (this.data.creator.selectedTheme)
		{
		    this.nextContainer = new fx.components.Box("back-container");
            this.nextButton = new fx.components.IconButton( {icon: fx.assets.arrowNext} );
            let text = new fx.components.Text({text : fx.text("Budget"), className : "button-label link"});
            this.nextContainer.addChild(text, {width: 100, height : 20, top : 10, left : 0})
            this.nextContainer.addChild(this.nextButton, {width:40, height:40, left : 110, top : 0})
            this.addChild( this.nextContainer, {top : 15, right : 15, width:150, height:40});
		}
	}

    onReady()
    {
        super.onReady();

		if (this.exitContainer)
			this.on("click", this._onExit, this.exitContainer);

        this.on("click", this._onBack, this.backContainer);
		this.on("click", this._onClick, this.containerCategories);

		if (this.nextContainer)
            this.on("click", this._onNext, this.nextContainer);

		this.loading(true, fx.text("Chargement"));

		if (this.themeTag.id == 0)
		{
			this.data.themeid = 0;
			this.data.event("next-step");
		}
		else
			this.data.themes.load( this.themeTag, true ); 
    }

	onDataEvent(e)
    {
        if (e.type == "themes-loaded")
            this._themesLoaded();
    }

	_themesLoaded()
	{
		let themes = this.data.themes.getThemes(this.themeTag);

		if (this.data.choosedThemeTag && !themes.find({id : 0}) && !themes.find({original : 0}) )
			themes.unshift({id : 0, thumb_square : "/app/assets/images/album-cover-vierge.png", name : fx.text("Album Blanc")});

		for (let i = 0; i < themes.length; i++)
		{
			let theme = themes.getItemAt(i);
			let renderer = new shared.renderers.ThemeRenderer(theme);
			if (theme.id == this.data.creator.selectedTheme)
				renderer.addClass("selected");

            this.containerCategories.addChild( renderer, {width:220, height : 240} );
		}

		this.containerCategories.show();
		this.loading(false);
	}

	_onExit()
	{
		this.data.event("step-PreviewAI");
	}

    _onBack()
    {
		this.hideEffect = "hslideout";

        this.data.event("previous-step");
    }

	_onNext()
	{
		this.data.event("step-Preview");
	}

    _onClick(event)
    {
		
		let target = this.getChildFromUI(fx.dom.parent(event.target, ".ThemeRenderer"));
		
		if(target)
		{
			if (fx.get("mode") == "creating-ia" || fx.get("mode") == "created-ia")
			{
				this.data.creator.selectedTheme = target.data.id;

				if (this.data.creator.bookUpdated && fx.get("mode") == "creating-ia")
				{
					this._popup = new shared.popups.ConfirmUpdateTheme(event.detail);
					this.popup(this._popup);
					this.on("confirmed", this._onConfirmed, this._popup);
				}
				else
					this.data.event("next-step");
			}
			else
			{
				this.data.themeid = target.data.id;
				this.data.event("next-step");
			}
		}
    }

	_onConfirmed()
	{
		this.data.event("next-step");
	}


});